import { render, staticRenderFns } from "./r-avatar-dialog.vue?vue&type=template&id=4606f546&scoped=true"
import script from "./r-avatar-dialog.vue?vue&type=script&lang=js"
export * from "./r-avatar-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-avatar-dialog.vue?vue&type=style&index=0&id=4606f546&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606f546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4606f546')) {
      api.createRecord('4606f546', component.options)
    } else {
      api.reload('4606f546', component.options)
    }
    module.hot.accept("./r-avatar-dialog.vue?vue&type=template&id=4606f546&scoped=true", function () {
      api.rerender('4606f546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/avatar/r-avatar-dialog.vue"
export default component.exports